<span class="badge rounded-pill text-bg-success ms-1"
      [matTooltip]=reviewsLabel()
      matTooltipPosition="above">{{'feedback_reviewed' | translate}}&nbsp;<i class="fa-solid fa-check"></i></span>
